var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.limit,"layout":"prev, pager, next, jumper","total":_vm.totalNum},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }